import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';
import { ValidationHelper } from '../helpers/ValidationHelper';

@Component({
  selector: 'app-choose-username',
  templateUrl: './choose-username.component.html',
  styleUrls: ['./choose-username.component.scss']
})
export class ChooseUsernameComponent extends BaseComponent implements OnInit {

  username = "";
  success = true;
  serverError = false;
  serverErrorMessage = "";
  privacyPolicyError = false;
  invalidUsername = false;

  @Output() onSuccess = new EventEmitter();

  constructor() {
    super();
  }

  ngOnInit() {

  }

  onUsernameChange(username) {
    this.username = username;
  }

  register() {

    this.privacyPolicyError = false;
    if (document.getElementById("privacyPolicyCheckbox")["checked"] === false) {
      this.privacyPolicyError = true;
      return;
    }

    if (!ValidationHelper.isValidUsername(this.username)) {
      this.invalidUsername = true;
    }
    else {
      this.onSuccess.emit(this.username);
    }
  }

}